import { inject, Injectable } from '@angular/core';

import { WorkflowAutomation } from '@core/workflow-automations-types';
import { AutomationListItem } from '@recruitee/workflow-automations-types';

import { AutomationDescriptionHelper } from './automation-description.helper';

@Injectable({ providedIn: 'root' })
export class AutomationListItemHelper {
  private readonly automationDescriptionHelper = inject(AutomationDescriptionHelper);

  public getAutomationListItem(automation: WorkflowAutomation): AutomationListItem | null {
    if (!automation.actions.length) return null;
    const triggerDescription = this.automationDescriptionHelper.getTriggerDescription(
      automation.trigger,
    );

    const conditionsDescription = this.automationDescriptionHelper.getConditionsDescription(
      automation.conditions,
    );

    const actionDescriptions = automation.actions.map(action =>
      this.automationDescriptionHelper.getActionDescription(action),
    );
    const firstAction = automation.actions[0];

    return {
      id: automation.id!,
      triggerType: automation.trigger.type,
      actionType: firstAction.type,
      label: this.automationDescriptionHelper.getAutomationDescription(
        triggerDescription,
        conditionsDescription,
        actionDescriptions,
      ),
      icon: firstAction.iconName,
      actionsCount: automation.actions.length,
    };
  }
}
